import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { workspaceApi } from '../api/workspaceApi';

export function useBootstrap(locationId: number | null | undefined) {
  return useQuery({
    queryKey: keys.workspace.bootstrap(locationId ?? 0),
    queryFn: ({ signal }) => workspaceApi.getBootstrap(locationId!, { signal }),
    enabled: locationId != null,
    staleTime: Infinity,
  });
}
